import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: ${colors.white};
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 90%;
  position: relative;
  box-shadow: 0 20px 40px rgba(18, 34, 67, 0.3);
  animation: modalSlideIn 0.3s ease-out;

  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 768px) {
    padding: 24px;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${colors.lightGray};
  }

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
`;

export const ModalTitle = styled.h2`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${colors.darkBlue};
  text-align: center;
  margin: 0 0 32px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  @media (min-width: 480px) {
    flex-direction: row;
  }
`;

export const FormatButton = styled.button<{ $format: "csv" | "vcf" }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 20px;
  border-radius: 16px;
  border: 2px solid transparent;
  background: ${({ $format }) =>
    $format === "csv"
      ? `linear-gradient(135deg, ${colors.green}15, ${colors.green}05)`
      : `linear-gradient(135deg, ${colors.blue}15, ${colors.blue}05)`};
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Noto Sans Hebrew", sans-serif;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 14px;
    padding: 2px;
    background: ${({ $format }) =>
      $format === "csv"
        ? `linear-gradient(135deg, ${colors.green}, ${colors.green}80)`
        : `linear-gradient(135deg, ${colors.blue}, ${colors.blue}80)`};
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px
      ${({ $format }) =>
        $format === "csv" ? `${colors.green}30` : `${colors.blue}30`};

    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(0);
  }

  span {
    font-size: 20px;
    font-weight: 600;
    color: ${({ $format }) => ($format === "csv" ? colors.green : colors.blue)};
    margin-bottom: 4px;
  }

  small {
    font-size: 14px;
    font-weight: 400;
    color: ${colors.blueGray};
    text-align: center;
    line-height: 1.2;
  }

  @media (max-width: 768px) {
    padding: 20px 16px;

    span {
      font-size: 18px;
    }

    small {
      font-size: 13px;
    }
  }
`;
